import React from "react";
import AppDataTable from "./AppDataTable";
import Icon from "@mdi/react";
import {
  mdiKeyVariant,
  mdiAutorenew,
  mdiClipboardTextClockOutline,
} from "@mdi/js";
import "./AppDataTable.css";

const getStatusBadgeClass = (label) => {
  if (label === "Activo") return "table-badge table-badge--active";
  if (label === "Vencida") return "table-badge table-badge--danger";
  return "table-badge table-badge--muted";
};

export const TechnicianList = ({ openModal, technicians, loading = false }) => {
  const getSubscriptionStatusLabel = (row) => {
    if (!row?.endDate) return row?.status_sub == 1 ? "Activo" : "Inactivo";
    const endDate = new Date(row.endDate);
    if (Number.isNaN(endDate.getTime()) || endDate < new Date()) return "Vencida";
    return row.status_sub == 1 ? "Activo" : "Inactivo (vigente)";
  };

  const columns = [
    {
      name: "Cod.",
      selector: (row) => `00${row.id_technician}`,
      sortable: true,
      center: true,
      width: "80px",
      minWidth: "70px",
    },
    {
      name: "Nombre",
      selector: (row) => row.full_name,
      sortable: true,
      center: true,
      wrap: true,
      grow: 2,
      minWidth: "120px",
    },
    {
      name: "C.I.",
      selector: (row) => row.ci,
      sortable: true,
      center: true,
      minWidth: "100px",
    },
    {
      name: "Última Suscripción",
      selector: (row) => row.code_sub ?? "N/A",
      sortable: true,
      center: true,
      wrap: true,
      minWidth: "110px",
    },
    {
      name: "Fecha Acaba",
      selector: (row) => row.endDate ?? "N/A",
      sortable: true,
      center: true,
      minWidth: "100px",
    },
    {
      name: "Estado",
      cell: (row) => {
        const label = getSubscriptionStatusLabel(row);
        return <span className={getStatusBadgeClass(label)}>{label}</span>;
      },
      sortable: true,
      center: true,
      minWidth: "110px",
    },
    {
      name: "Acciones",
      cell: (row) => (
        <div className="table-actions table-actions--stack-sm">
          <button
            type="button"
            onClick={() => openModal("reset", row)}
            className="table-action table-action--labeled table-action--danger"
            title="Restablecer contraseña del abogado"
          >
            <Icon path={mdiKeyVariant} size={0.95} />
            <span className="table-action__label">Restablecer clave</span>
          </button>
          <button
            type="button"
            onClick={() => openModal("subscription", row)}
            className="table-action table-action--labeled table-action--primary"
            title="Renovar suscripción"
          >
            <Icon path={mdiAutorenew} size={0.95} />
            <span className="table-action__label">Renovar plan</span>
          </button>
          <button
            type="button"
            onClick={() => openModal("history", row.id_technician)}
            className="table-action table-action--labeled table-action--secondary"
            title="Historial de suscripciones"
          >
            <Icon path={mdiClipboardTextClockOutline} size={0.95} />
            <span className="table-action__label">Historial</span>
          </button>
        </div>
      ),
      center: true,
      minWidth: "200px",
      grow: 1,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <div className="relative">
      {loading ? (
        <div className="table-loading">
          <div className="table-loading__spinner" role="status" aria-label="Cargando abogados" />
        </div>
      ) : (
        <AppDataTable
          columns={columns}
          noDataComponent={<p className="table-empty">No hay abogados registrados.</p>}
          data={technicians}
        />
      )}
    </div>
  );
};
